import { Document } from "@react-pdf/renderer";
import "../styles/Font";
import CoverFillingCyclePDF from "./CoverFillingCyclePDF";
import { useTranslation } from "react-i18next";
import { FillingCyclePdfContent } from "./FillingCyclePdfContent";

const pngAssetsContext = require.context(
  "../../../static/assets",
  false,
  /\.png$/,
);
const availablePngAssets = pngAssetsContext.keys();
const defaultLogo = require("../../../static/assets/logo_rvg.png");

const getClientLogo = (corporation) => {
  if (!corporation) {
    return defaultLogo;
  }

  const key = `./${corporation}.png`;
  if (availablePngAssets.includes(key)) {
    return pngAssetsContext(key);
  }

  console.warn(
    `Logo "${corporation}" not found in static assets. Falling back to default.`,
  );
  return defaultLogo;
};

export const FillingCyclePdfDocument = ({
  timeLine,
  dropOff,
  corporationName,
  collectionFillingLevel,
  pdfData,
  clientName,
  wasteName,
}) => {
  const { i18n } = useTranslation();
  const clientLogo = getClientLogo(timeLine?.corporation);

  return (
    <Document
      creator="Akanthas"
      producer="Akanthas"
      style={{ fontFamily: "Open Sans" }}
    >
      <CoverFillingCyclePDF
        timeLine={timeLine}
        dropOff={dropOff}
        language={i18n.language}
        clientLogo={clientLogo}
        corporationName={corporationName}
        collectionFillingLevel={collectionFillingLevel}
        numberOfAnomaly={pdfData.numberOfAnomaly}
        oneImage={pdfData.oneImage}
        clientName={clientName}
        wasteName={wasteName}
        numberOfStars={pdfData.numberOfStars}
      />

      <FillingCyclePdfContent
        data={pdfData.finalData}
        timeLine={timeLine}
        collectionFillingLevel={pdfData.collectionFillingLevel}
        numberOfAnomaly={pdfData.numberOfAnomaly}
        chartImageUrl={pdfData.chartImgData}
        cycleChartImgUrl={pdfData.cycleChartImgData}
        materialChartImgData={pdfData.materialChartImgData}
        numberOfStars={pdfData.numberOfStars}
        contaminants={pdfData.contaminants}
        numberOfPackmat={pdfData.numberOfPackmat}
        clientRegisteredWeight={pdfData.clientRegisteredWeight}
        uniqueHistoryCycle={pdfData.uniqueHistoryCycle}
        numberOfObjects={pdfData.numberOfObjects}
        comments={pdfData.comments}
        oneImage={pdfData.oneImage}
      />
    </Document>
  );
};
